<template>
  <div class="banner-container">
    <div class="banner-container__icon-and-message">
      <span class="icon">
        <MegaPhone :iconColor="computedColor" />
      </span>
      <p class="message">
        <span v-html="banner.message"></span>
      </p>
    </div>

    <div
      class="banner-container__close"
      @click.prevent="() => $emit('onButtonClick')"
    >
      <span class="sr-only">Dismiss</span>
      <CrossIcon :iconColor="computedColor" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import { useGlobalStore } from "@/stores/globalStore";

import MegaPhone from "@/components/icons/MegaPhone.vue";
import CrossIcon from "@/components/icons/Cross.vue";

defineProps({
  banner: {
    type: Object,
    required: false,
    default: () => {
      return {
        message: "<p>Banner message<p>",
      };
    },
  },
});
const store = useGlobalStore();
const computedColor = computed(() => (store.getIsDarkMode ? "white" : "black"));
</script>

<style lang="scss" scoped>
$shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
$banner-bg: #5a67d8;
.banner-container {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.25rem;
  color: $white;
  background-color: $banner-bg;
  box-shadow: $shadow;
  z-index: 10;

  &__icon-and-message {
    display: flex;
    flex: 1 1 0%;
    align-items: center;
    max-width: 992px;
    padding: 1rem;

    .icon {
      display: none;

      @include breakpoint($min-s) {
        display: flex;
        border-radius: 0.5rem;
        margin-right: 0.75rem;
        padding: 0.5rem;
        //background-color: #fff;
        width: 32px;
      }
    }

    .message {
      font-weight: 500;
    }
  }

  &__close {
    padding: 0.5rem;
    display: flex;
    pointer-events: auto;
    cursor: pointer;
    border-radius: 0.5rem;

    &:hover {
      background-color: lighten($banner-bg, 5%);
    }

    .v-icon {
      color: inherit;
    }
  }
}
</style>
